var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav-list"},_vm._l((_vm.categoryList),function(item){return _c('li',{key:item.type,staticClass:"nav-item",class:{ 'nav-item--active': _vm.checkType === item.type },attrs:{"title":item.content},on:{"click":function($event){return _vm.selectedCategory(item)}}},[_vm._v(" "+_vm._s(item.content)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }